import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { theme } from '../../utils/themeProvider.js';
import { customArcherColors } from '../../utils/customArcherColors.js';
import '@mui/styles';
import { snackbarContentClasses, Snackbar } from '@mui/material';
import '@mui/material/styles';
import 'uuid/v4';
import { IconButton } from '../IconButton/IconButton.js';
import { Typography } from '../Typography/Typography.js';

var _snackbarRoot;

var styles = {
  success: {
    '& div': {
      backgroundColor: customArcherColors.alertColors && customArcherColors.alertColors.positive
    }
  },
  error: {
    '& div': {
      backgroundColor: customArcherColors.alertColors && customArcherColors.alertColors.error
    }
  },
  info: {
    '& div': {
      backgroundColor: customArcherColors.alertColors && customArcherColors.alertColors.informative
    }
  },
  warning: {
    '& div': {
      backgroundColor: customArcherColors.alertColors && customArcherColors.alertColors.warning
    }
  },
  snackbarRoot: (_snackbarRoot = {
    margin: 0,
    top: 0,
    padding: theme.spacing(0),
    '&>div': {
      margin: theme.spacing(0),
      padding: theme.spacing(2),
      flexWrap: 'nowrap',
      minWidth: 'auto'
    }
  }, _defineProperty(_snackbarRoot, "& .".concat(snackbarContentClasses['action']), {
    margin: 0,
    padding: 0,
    '&>button': {
      color: theme.palette.background.paper,
      margin: theme.spacing(-1),
      padding: theme.spacing(1)
    },
    '&>button:hover': {
      backgroundColor: 'rgba(255,255,255, .12)',
      borderRadius: 50
    },
    '&>button:focus': {
      backgroundColor: 'rgba(255,255,255, .25)',
      borderRadius: 50
    }
  }), _defineProperty(_snackbarRoot, "& .".concat(snackbarContentClasses['message']), {
    margin: theme.spacing(0, 2, 0, 0),
    padding: 0,
    maxWidth: '500px',
    '&>h4': {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    }
  }), _snackbarRoot),
  noCloseAction: _defineProperty({}, "& .".concat(snackbarContentClasses['message']), {
    margin: theme.spacing(0)
  })
};

var SnackBar = function SnackBar(_ref) {
  var open = _ref.open,
      message = _ref.message,
      onRequestClose = _ref.onRequestClose,
      closeAction = _ref.closeAction,
      variant = _ref.variant,
      translate = _ref.translate,
      sx = _ref.sx;
  var success = styles.success,
      error = styles.error,
      info = styles.info,
      warning = styles.warning,
      snackbarRoot = styles.snackbarRoot,
      noCloseAction = styles.noCloseAction;

  var getClass = function getClass() {
    var result = success;

    if (variant) {
      switch (variant) {
        case 'error':
          result = error;
          break;

        case 'info':
          result = info;
          break;

        case 'warning':
          result = warning;
          break;

        default:
          result = success;
          break;
      }
    }

    return result;
  };

  return /*#__PURE__*/React.createElement(Snackbar, {
    open: open,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    autoHideDuration: 8000,
    role: "alertdialog",
    onClose: onRequestClose,
    message: /*#__PURE__*/React.createElement(Typography, {
      variant: "h4",
      component: "p"
    }, message),
    action: closeAction && /*#__PURE__*/React.createElement(IconButton, {
      icon: "Close",
      fontSize: "small",
      color: "inherit",
      key: "snackbar-close",
      onClick: onRequestClose,
      "aria-label": translate('cmmn:clear')
    }),
    sx: [getClass(), snackbarRoot, closeAction ? undefined : noCloseAction, sx]
  });
};

SnackBar.displayName = 'Snackbar';
export { SnackBar };